module.exports = __webpack_public_path__ + "static/media/sass-1.6ff2cc60.svg";